import { render } from "./IssueModal.vue?vue&type=template&id=50dfed22"
import script from "./IssueModal.vue?vue&type=script&lang=js"
export * from "./IssueModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__